import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const removeAuthoringLegislationGroup = api(async function removeAuthoringLegislationGroup({ id, force }) {
    return mutate(
        gql`
            mutation RemoveAuthoringLegislationGroup($id: String!, $force: Boolean) {
                removeAuthoringLegislationGroup(id: $id, force: $force) {
                    removedGroupIds
                    removedJunctionIds
                }
            }
        `,
        { id, force },
        { returns: "removeAuthoringLegislationGroup" }
    )
})
